import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { IAiAssistant } from 'modules/cms/seo/ai-assistant/interfaces';

class AiAssistantService extends EntityApiService<IAiAssistant> {
  getAssistant = (): any => {
    return ApiClientService.get(this.getPath(''));
  };

  updateAiAssistant = (assistant: Partial<IAiAssistant>): any => {
    return ApiClientService.post(this.getPath(''), assistant);
  };
}

export default new AiAssistantService('/ms-cms/api/ai/assistant');
